module.exports = __webpack_public_path__ + "static/media/bank-grey.b04b1f97.svg";